import { render } from "./Menu.vue?vue&type=template&id=445a54b8&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=445a54b8&lang=css"
import "./Menu.vue?vue&type=style&index=1&id=445a54b8&lang=scss&scoped=true"
import "./Menu.vue?vue&type=style&index=2&id=445a54b8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445a54b8"]])

export default __exports__